import paths from "routes/paths";
import CommonUtils from "services/common/utils";
import XHTTP from "services/api/xhttp";

class ConfigSectorsApi {
  static END_POINTS = {
    general: paths.api.config.sectors.general,
    data: paths.api.config.sectors.data,
    update: paths.api.config.sectors.update,
  };

  static getSectorsByArea(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${this.END_POINTS.general}?${queryString}`, {
      method: "get",
    });
  }
  static getSectorsData(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${this.END_POINTS.data}?${queryString}`, {
      method: "get",
    });
  }

  static updateSector(id, data) {
    return XHTTP(this.END_POINTS.update.replace(":id", id), {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }
}

export default ConfigSectorsApi;
